export default __webpack_public_path__ + "static/media/spinner.f76e8aa2.svg";